import {Component, EventEmitter, Injector, OnInit, Output, ViewChild} from '@angular/core';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {finalize} from 'rxjs/operators';
import {
    UserListDto

} from '@shared/service-proxies/service-proxies';
import {AppComponentBase} from '@shared/common/app-component-base';
import {Subject} from 'rxjs';
import {FieldAgentService} from '@app/webshop/field-agent/shared/services/field-agent.service';

@Component({
    selector: 'viewAllManagersModal',
    templateUrl: './view-all-managers-modal.component.html',
    styleUrls: ['view-all-managers-modal.component.less']
})
export class ViewAllManagersModalComponent extends AppComponentBase implements OnInit {

    get selectedManager(): UserListDto | undefined {
        return this._fieldAgentService.selectedManager;
    }

    @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('viewAllManagersModal', {static: true}) modal: ModalDirective;

    active = false;
    saving = false;

    get customerUsersValue(): UserListDto[] {
        return this._fieldAgentService.customerUsersValue;
    }

    constructor(
        injector: Injector,
        private _fieldAgentService: FieldAgentService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
    }

    show(): void {
        this.active = true;
        this.modal.show();
    }

    onSubmit() {
        this.onSelect.next(this.selectedManager);
        this.close();
    }

    close(): void {
        this.active = false;
        this._fieldAgentService.unselectManager();
        this.modal.hide();
    }

    selectManager(user: UserListDto) {
        this._fieldAgentService.selectManager(user);
        this.onSubmit();
    }
}



